module.exports = __webpack_public_path__ + "fad1e9200f8d147e874cb36d9e052857.png";